import core from '../../../js/core/core'

import * as types from '../mutation-types'

// initial state
const state = {
    int_marketToggle : 1,
    loadingScreen: null,
    requestAllow: true,
    isMobile: false,
    minSize: 1024,
    subLoading: null,
    fullLoading: null,
    oddsFormatDec : 1,
    betSlipAny : 1,
    showFloating: false,
    simDisp: 1,
    refreshScreen: null,
    isCollapse: true,
    showMoreEvent: false,
    scAllBetTab: {
      '1': ['1','2','8','9','46','47','48','49'],
      '2': ['3','5','10','18','46','47','48','49','19','20'],
      '3': ['7','16'],
      '4': ['1','2','3','4','5','7','8','9','10','11','14','15','16','17','18','20','22','23','24','25','26','32','33','46','47','48','49','51'],
      '5': ['59','60','61','62','63','64','65','66','67','68','69','70','71','72','73'],
      '6': ['34','35'],
      '7': ['1','2','3','4','5','6','7','8','9','10','11','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','52'],
      '8': ['1','2','4','5','6','7','8','9','11'],
    },
    bkAllBetTab: {
      '7': ['1','2','3','8','9','10','12','13','50','51','53','54','55','56'],
      '8': ['1','2','4','5','6','7','8','9','11','12','13'],
      '5': ['1','2','3','4','5','6','7','8','9','10','11','12','13'],
      '6': ['50','51','53','54','55','56'],
    },
    osAllBetTab: {
      '7': ['1','2','3','4','11','8','9','10','12','13'],
       '8': ['1','2','4','5','6','7','8','9','11','12','13'],
       '9': ['13','20','21','22','23','24','25','26','27','28','29','30'], // innings
       '10': ['80','81','82','83'], // team
    },
    isShowBtModal: false,
    isShowFilter: false,
    filter_type: 1, //1: filter league, 2: search 
    loadGameHeader: true,
    titleSport: window.titleSport,
    settle_unsettled: 1, // 1: unsettled, 2: settle
    selectedSport: null,
    filterEventArr: null,
    mulpSetting: window.mulpSetting,
    currentTab: 1,
    previousTab: 1,
    currSlideIndex: 0,
    matchSchdTab: 4,
    actHistory: {
      selDate: null,
      theme: 2, // default 1: light, 2: dark
      selCtr: null,
    },
    TVfullscreen: '0',
}

// getters
const getters = {
    int_marketToggle: state => state.int_marketToggle,
    loadingScreen: state => state.loadingScreen,
    requestAllow: state => state.requestAllow,
    isMobile: state => state.isMobile,
    minSize: state => state.minSize,
    subLoading: state => state.subLoading,
    fullLoading: state => state.fullLoading,
    oddsFormatDec : state => state.oddsFormatDec,
    betSlipAny : state => state.betSlipAny,
    showFloating: state => state.showFloating,
    simDisp: state => state.simDisp,
    refreshScreen: state => state.refreshScreen,
    isCollapse: state => state.isCollapse,
    showMoreEvent: state => state.showMoreEvent,
    scAllBetTab: state => state.scAllBetTab,
    bkAllBetTab: state => state.bkAllBetTab,
    osAllBetTab: state => state.osAllBetTab,    
    isShowBtModal: state => state.isShowBtModal,
    isShowFilter: state => state.isShowFilter,
    filter_type: state => state.filter_type,
    loadGameHeader: state => state.loadGameHeader,
    titleSport: state => state.titleSport,
    settle_unsettled: state => state.settle_unsettled,
    selectedSport: state => state.selectedSport,
    filterEventArr: state => state.filterEventArr,
    mulpSetting: state => state.mulpSetting,
    currentTab: state => state.currentTab,
    previousTab: state => state.previousTab,
    currSlideIndex: state => state.currSlideIndex,
    matchSchdTab: state => state.matchSchdTab,
    actHistory: state => state.actHistory,
    TVfullscreen: state => state.TVfullscreen,
}

// actions
const actions = {
  getFilterEventList (context, payload) {
    let url = '/filter-event'
    if (this.getters.account.previewFlag == true) {
      url = '/filter-event-preview'
    }
    core.$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: {
        sorting: 1,
        sportid: payload.sportid,
      },
    }).done(((res)=> {
      this.commit('FILTER_EVENT', res.allEvent)
      if(res.earlyParlayDateList){
        this.commit('PARLAYDATELIST', res.earlyParlayDateList);
      }
    }).bind(this)).catch((errRes)=> {
      console.log(errRes)
    })
  },
}

// mutations
const mutations = {
    [types.MARKETTOGGLE](state, payload ){
        state.int_marketToggle = payload
    },
    [types.ODDSFORMATDEC](state, payload ){
      state.oddsFormatDec = payload
    },
    [types.BETSLIPANY](state, payload ){
      state.betSlipAny = payload
    },
    [types.LOADINGSCREEN](state, payload ){
        state.loadingScreen = payload
    },
    [types.REQUEST_ALLOW] (state, payload ) {
        state.requestAllow = payload
    },
    [types.IS_MOBILE] (state, payload){
      state.isMobile = payload
    },
    [types.SUBLOAD] (state, payload){
      state.subLoading = payload
    },
    [types.FULL_LOAD] (state, payload){
      state.fullLoading = payload
    },
    [types.SHOW_FLOATING] (state, payload){
      state.showFloating = payload
    },
    [types.SIM_DISP] (state, payload){
      state.simDisp = payload
    },
    [types.REFRESHSCREEN] (state, payload){
      state.refreshScreen = payload
    },
    [types.IS_COLLAPSE] (state, payload){
      state.isCollapse = payload
    },
    [types.SHOWMOREEVENT] (state, payload){
      state.showMoreEvent = payload
    },
    [types.SHOW_BTMODAL] (state, payload){
      state.isShowBtModal = payload
    },
    [types.SHOW_FILTER] (state){
      // state.isShowFilter = payload
      state.isShowFilter = (state.isShowFilter === false ? true : false)
      
      if(state.isShowFilter){
        
        var lge;

        if(this.getters.sortedEvents.length > 0){
          this.commit('LEAGUE_FILTER', [])
          lge=_.groupBy(this.getters.sortedEvents, 'lgeid')
          let ret = []
          let ttlret = []
          _.forEach(lge, ((lgeinfo, lgeid) => {
            ret = {'id' : (lgeid*1), 'c':lgeinfo.length, 'f':(lgeinfo[0].lgecapt).charAt(0), 'lgecapt':lgeinfo[0].lgecapt}
  
            ttlret.push(ret)
          }))
          this.commit('LEAGUE_FILTER', ttlret)
          this.commit('TODAYRBLEAGUELIST', ttlret)

        }


        this.commit('LEAGUELIST', [])
        if(this.getters.arr_selectedTemplate.int_marketToggle=='1'){
          this.dispatch('getTodayRBLaugueList', {
            enableLoading:true,
            token: token.arr_2,
            isGameBanner: 0,
          })
        }else{
          this.dispatch('getLaugueList', {
            enableLoading:true,
            token: token.arr_2,
            isGameBanner: 0,
          })
        }
      }
    },
    [types.FILTERTYPE] (state, payload){
      state.filter_type = payload
    },
    [types.LOADGAMEHEADER] (state, payload){
      state.loadGameHeader = payload
    },
    [types.SETTLE_UNSETTLED] (state, payload){
      state.settle_unsettled = payload
    },
    [types.SELECTED_SPORT] (state, payload) {
      state.selectedSport = payload
    },
    [types.FILTER_EVENT] (state, payload) {
      state.filterEventArr = payload
    },
    [types.CURRENT_TAB] (state, payload) {
      if(state.currentTab != 4) {
        this.commit('PREVIOUS_TAB', state.currentTab)
      }
      state.currentTab = payload
    },
    PREVIOUS_TAB (state, payload) {
      state.previousTab = payload
    },
    CURR_SLIDE_INDEX (state, payload) {
      state.currSlideIndex = payload
    },
    MATCH_SCHEDULE_TAB (state, payload) {
      state.matchSchdTab = payload
    },
    ACT_HISTORY (state, payload) {
      state.actHistory = payload
    },
    TV_FULL_SCREEN (state, payload) {
      state.TVfullscreen = payload
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/home.js